import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var RecepcionComponent = /** @class */ (function () {
    function RecepcionComponent() {
        this.rows = [];
        this.form = new FormGroup({
            superedif: new FormControl('', Validators.compose([
                Validators.required
            ])),
            destino_cont: new FormControl('', Validators.compose([
                Validators.required
            ]))
        });
        if (!JSON.parse(localStorage.getItem("recepcion"))) {
            localStorage.setItem("recepcion", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("recepcion"));
            this.form.controls['superedif'].setValue(this.rows[0] ? this.rows[0].superedif : '');
            this.form.controls['destino_cont'].setValue(this.rows[0] ? this.rows[0].destino_cont : '');
        }
    }
    RecepcionComponent.prototype.add_recepcion = function () {
        localStorage.setItem("recepcion", JSON.stringify([]));
        this.actualRow = localStorage.getItem("recepcion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            superedif: this.form.value.superedif,
            destino_cont: this.form.value.destino_cont
        });
        localStorage.setItem("recepcion", JSON.stringify(this.rows));
    };
    RecepcionComponent.prototype.delete_recepcion = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("recepcion", JSON.stringify(this.rows));
            }
        }
    };
    return RecepcionComponent;
}());
export { RecepcionComponent };
